import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home';
import About from "@/views/About";
import Catalog from '@/views/Catalog';
import NetworkVis from "@/views/NetworkVis";
import PlanBuilder from "@/views/PlanBuilder";
import ConceptViewer from "@/views/ConceptViewer";


Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/roadmaps',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/vis',
      name: 'networkVis',
      component: NetworkVis
    },
    {
      path: '/roadmaps',
      name: 'catalog',
      component: Catalog
    },
    {
      path: '/roadmaps/:slug',
      name: 'planBuilder',
      component: PlanBuilder
    },
    {
      path: '/concepts/:slug',
      name: 'conceptViewer',
      component: ConceptViewer
    }
  ]
})
